<template>
  <LcCard body-class="pick-lottery-quick-pick-quantity flex items-center justify-between">
    <div>
      <h2 class="paragraph-bold">
        {{ $t('picklottery.quickpick.quantity.headline') }}
      </h2>
      <p class="paragraph-small-text text-secondary-secondary" :class="{ error: value > max }">
        {{ $t('picklottery.quickpick.quantity.hint', max) }}
      </p>
    </div>

    <QuantitySelector v-bind="{ min, max }" v-model:value="value" />
  </LcCard>
</template>

<script lang="ts" setup>
type PickLotteryQuickPickQuantityProps = {
  max?: number
  min?: number
}

const { max = 100, min = 1 } = defineProps<PickLotteryQuickPickQuantityProps>()

const value = defineModel('value', {
  default: 1,
  type: Number,
})
</script>

<style lang="scss" scoped>
.pick-lottery-quick-pick-quantity {
  .error {
    color: token('color/text/accent/accent-danger');
  }
}
</style>
